import * as React from 'react';
import { DrawerContentScrollView, DrawerItemList, DrawerItem } from '@react-navigation/drawer';
import { Picker, Image, ImageBackground, Platform } from 'react-native';
import { Content, Text, List, ListItem, Icon, Container, Left, Right, Badge, Button, View, StyleProvider, getTheme, variables, Item, Thumbnail, Body, Separator, Footer, Header } from 'native-base';
import FontAwesome from 'react-native-vector-icons/FontAwesome';
import MaterialDrop from '../../components/materialDrop';
import * as Updates from 'expo-updates';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { useRoute } from '@react-navigation/native';
import Constants from 'expo-constants';
import Alert from '../alert';
import LocalStorage from '../../api/LocalStorage';

const drawerCover = require('../../../assets/drawer-calcal.png');
const drawerImage = require('../../../assets/logo-kitchen-sink.png');

import styles from './style';

const routesA = [
	{
		route: 'Dashboard',
		hash: 'home',
		caption: 'Dashboard',
		icon: 'apps'
	},
	{
		route: 'DailyEntries',
		//hash: "dailyEntries",
		caption: 'Daily Entries',
		icon: 'calendar'
	},
	{
		route: 'People',
		caption: 'People',
		icon: 'person'
	},

	{
		route: 'BankImport',
		//hash: "dailyEntries",
		caption: 'Bank Import',
		icon: 'ios-download'
	}
];
/*
 */
const isWeb = Platform.OS == 'web';

export default function CustomDrawerContent(props) {
	const { vatReg, userInfo } = useSelector(
		state => ({
			vatReg: state.globalReducer.busDetails.vatRegistered,
			userInfo: state.loginReducer.userInfo
		}),
		shallowEqual
	);

	const { user } = userInfo || null;
	const { id, revisionId } = Constants.manifest || {};
	const { version, sdkVersion } = isWeb ? Constants.manifest : Updates.manifest;

	const dropActions = user.demo_id ? ['Log Out'] : ['Profile', 'Subscription', 'Change PIN', 'Log Out'];

	const userTap = (i, e) => {
		__DEV__ && console.log(i);
		if (i == 'Subscription') isWeb ? (window.location = 'https://calcal.uk/membership-account/') : props.navigation.navigate({ name: 'SubscriptionContainer' });
		if (i == 'Profile') Platform.OS == 'web' ? (window.location = 'https://calcal.uk/your-profile/') : props.navigation.navigate({ name: 'Profile' });
		if (i == 'Change PIN') props.navigation.navigate({ name: 'Pin', params: { change: 'change' } });
		if (i == 'Log Out') logOut();
	};

	const dispatch = useDispatch();
	const logOut = () => {
		if (Platform.OS == 'web') return actuallyLogout();
		Alert.alert(
			'Logging Out',
			'Do you want to log out of the accounting app?',
			[
				{ text: 'Cancel', style: 'cancel' },
				{
					text: 'Log Out',
					onPress: actuallyLogout
				}
			],
			{ cancelable: true }
		);
	};

	const actuallyLogout = () => {
		LocalStorage.removeUserAsync();
		dispatch({
			type: 'CLEAR_USER'
		});
		if (Platform.OS == 'web') {
			window.location = 'https://calcal.uk/log-out';
		} else {
			Updates.reloadAsync();
		}
	};

	const date = new Date();
	const timeToString = date.toISOString().split('T')[0];

	const itemTap = (route, params = null) => {
		props.navigation.navigate(route, params);
		//the stupid click-twice bug!
		if (Platform.OS == 'web') setTimeout(() => props.navigation.navigate(route, params), 500);
	};

	const icon = ({ focused, color, size }, icon) => (
		<Icon style={[focused ? styles.icon : styles.inactiveIcon, { width: 25, alignSelf: 'center', justifyContent: 'center' }]} color={color} size={size} name={icon} />
	);

	const showVat = vatReg && !user.freeLevel;
	//console.log(props.state);

	const stackNav = props.state && props.state.index == 0 && props.state.routes[0].state;
	//console.log('stackNav', stackNav);
	const tabNav = stackNav && stackNav.index == 0 && stackNav.routes[0].state;

	const routeName = tabNav ? tabNav.routeNames && tabNav.routeNames[tabNav.index] : stackNav?.routes && stackNav.routes[stackNav.index]?.name;
	//console.log('drawerContent', routeName, user);

	return (
		<>
			{false && props.fixed && (
				<Header>
					<Body></Body>
				</Header>
			)}
			<ImageBackground source={drawerCover} style={styles.drawerCover}>
				{!props.fixed && Platform.OS == 'web' && (
					<Button transparent style={{ alignSelf: 'flex-start', paddingTop: 30, paddingLeft: 0 }} onPress={() => props.navigation.closeDrawer()}>
						<Icon name="menu" style={{ fontSize: 28, paddingRight: 2, color: '#FFF' }} />
					</Button>
				)}
				<View />
				<Image square style={styles.drawerImage} source={drawerImage} />

				{/*<View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
					<MaterialDrop uri={user.hasLogo && user.thumbPath} text={user.display_name} actions={dropActions} onPress={(e, i) => userTap(dropActions[i])} destructiveButtonIndex={3} />
					<Icon name="settings" style={{ alignSelf: 'center', color: '#c9c9c9', margin: 12 }} />
				</View>*/}
				<MaterialDrop
					uri={user.hasLogo && user.thumbPath}
					text={user.display_name}
					actions={dropActions}
					onPress={(e, i) => userTap(dropActions[i])}
					destructiveButtonIndex={3}
					style={{ overflow: 'hidden' }}
				/>
			</ImageBackground>
			{!!props.fixed && Platform.OS == 'web' && (
				<View style={{ justifyContent: 'space-around', flexDirection: 'row', marginBottom: 5 }}>
					<Button
						small
						style={{ backgroundColor: '#87b87f', width: 50, height: 30, justifyContent: 'center' }}
						onPress={() =>
							itemTap('Entry', {
								addTrans: 'receipt',
								addDate: timeToString
							})
						}>
						<FontAwesome name="calendar-plus-o" style={{ fontSize: 16, color: 'white' }} />
					</Button>
					<Button
						small
						style={{ backgroundColor: '#d15b47', width: 50, height: 30, justifyContent: 'center' }}
						onPress={() =>
							itemTap('Entry', {
								addTrans: 'expense',
								addDate: timeToString
							})
						}>
						<FontAwesome name="calendar-minus-o" style={{ fontSize: 16, color: 'white' }} />
					</Button>
					<Button small style={{ backgroundColor: '#ffb752', width: 50, height: 30, justifyContent: 'center' }} onPress={() => itemTap('DailyEntries')}>
						<FontAwesome name="calendar" style={{ fontSize: 16, color: 'white' }} />
					</Button>
					<Button small style={{ backgroundColor: '#6fb3e0', width: 50, height: 30, justifyContent: 'center' }} onPress={() => itemTap('Invoice')}>
						<FontAwesome name="file" style={{ fontSize: 16, color: 'white' }} />
					</Button>
				</View>
			)}
			{!!props.fixed && Platform.OS == 'web' && <View style={{ height: 1, backgroundColor: '#c9c9c9' }} />}
			<DrawerContentScrollView {...props}>
				{false && <DrawerItemList {...props} />}
				{routesA.map((data, i) => (
					<DrawerItem {...props} focused={routeName === data.route} key={i} label={data.caption} onPress={() => itemTap(data.route)} icon={x => icon(x, data.icon)} />
				))}
				{showVat && <DrawerItem {...props} label="VAT" onPress={() => itemTap('Vat')} icon={x => icon(x, 'cut')} />}
				{false && <DrawerItem {...props} focused={routeName === 'TaxYears'} label="Tax" onPress={() => itemTap('TaxYears')} icon={x => icon(x, 'create')} />}
				<DrawerItem {...props} focused={routeName === 'Reports'} label="Reports" onPress={() => itemTap('Reports')} icon={x => icon(x, 'document')} />
				<View style={{ height: 1, backgroundColor: '#c9c9c9' }} />
				<DrawerItem {...props} focused={props.state.index == 1} label="Settings" onPress={() => itemTap('Settings')} icon={x => icon(x, 'settings')} />
				<DrawerItem label="Log Out" onPress={() => logOut()} icon={x => icon(x, 'lock')} />

				{__DEV__ && (
					<Separator bordered style={{ height: 1 }}>
						<Text>Dev mode</Text>
					</Separator>
				)}
			</DrawerContentScrollView>
			<Footer style={{ backgroundColor: 'transparent' }}>
				<Body style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-around' }}>
					<Text note>© CalCal Ltd.</Text>
					<Button
						transparent
						onPress={() => {
							//Sentry.captureException(new Error('Oops!'));
							Updates.reloadAsync();
						}}>
						<Text note style={{ margin: 10, height: 20 }}>
							Version {version || Constants.nativeAppVersion + ' r'}
						</Text>
					</Button>
				</Body>
			</Footer>
		</>
	);
}
